export const activeIngredients = `
 activeIngredientsPage: entry(slug: "active_ingredients", site: $site) {
    slug
    title
    url
    id
  }
  activeIngredients: entries(collection: "active_ingredients", site: $site, sort: "title asc") {
    data {
      __typename
    id
    slug
      ... on Entry_ActiveIngredients_ActiveIngredient {
        id
        slug
        meds_relations {
          title
          slug
        }
        shorthand
        last_modified(format: "d.m.Y")
        title
        therapeutic_serum_concentration
      }

    }
  }
`
